export const trackEvent = (name: string, payload: any = {}) => {
  if (window.gtag) {
    window.gtag("event", name, payload);
  }

  if (window.mixpanel) {
    window.mixpanel.track(name, payload);
  }
};
